import { render, staticRenderFns } from "./MasrafList.vue?vue&type=template&id=801458d2"
import script from "./MasrafList.vue?vue&type=script&lang=ts"
export * from "./MasrafList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports